import React, { Component } from 'react'
import { makeObservable, observable, reaction } from 'mobx'
import { observer, inject } from 'mobx-react'
import {
  SideBySideLayout,
  PrimaryButton,
  Text as BaseText,
  Box,
  Flex,
} from '../MDS-web-ui/src'
import { PageHeading } from '../components/PageHeading'
import { ActiveLink } from '../components/Link'
import * as Sentry from '@sentry/react'

// Sentry
import setupErrorTracking from './errorTracking'
setupErrorTracking()

// https://docs.sentry.io/clients/javascript/integrations/react/

const Text = (props) => (
  <BaseText
    mb={4}
    lineHeight={1.5}
    fontSize={[2, 3]}
    color="grayapptitle"
    {...props}
  />
)

const ErrorFallbackPage = () => (
  <SideBySideLayout useRouterLink={false} LinkComponent={ActiveLink}>
    <Flex flexDirection="column" css={{ textAlign: 'center' }}>
      <PageHeading mt={4} mb={4} color="grayapptitle" fontSize={[4, 5]}>
        Sorry, something went wrong
      </PageHeading>
      <Text>
        Our team has been notified, we&apos;ll fix it as soon as we can!
      </Text>
      <PrimaryButton mt={4} as="a" href="/" uppercase>
        Go back and try again
      </PrimaryButton>
    </Flex>
  </SideBySideLayout>
)

@inject('sessionStore')
@observer
export class ErrorBoundary extends Component {
  error = null

  constructor(props) {
    super(props)
    this.setupUserContext()
    makeObservable(this, {
      error: observable,
    })
  }

  setupUserContext() {
    const sessionStore = this.props.sessionStore

    reaction(
      () => sessionStore.authUser,
      () => sessionStore.authUser && this.setContext(sessionStore.authUser),
    )
  }

  setContext(user) {
    const context = {
      email: user.email,
      id: user.uid,
      name: user.displayName,
    }
    Sentry.setUser(context)
  }

  render() {
    return (
      <Sentry.ErrorBoundary fallback={<ErrorFallbackPage />}>
        {this.props.children}
      </Sentry.ErrorBoundary>
    )
  }
}
